import { useEffect, useState } from 'react';
import { getAllCompany } from '../../services/company/listCompanyService.js';

export const useCompaniesSelect = () => {
    const [companies, setCompanies] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const loadCompanies = async () => {
            try {
                const data = await getAllCompany();
                setCompanies(data);
            } catch {
                setError('Error cargando empresas.');
            } finally {
                setLoading(false);
            }
        };

        loadCompanies();
    }, []);

    return {
        companies,
        loading,
        error
    };
};